// FIXME: Use Constants in Redux instead and remove when the mobile is ready
export default {
  STATES: {
    NOTIFICATION_STATE_NEW: '@notification-state/new',
    NOTIFICATION_STATE_SEEN: '@notification-state/seen',
    NOTIFICATION_STATE_READ: '@notification-state/read'
  },
  TYPES: {
    NOTIFICATION_TYPE_INFO: '@notification-type/info',
    NOTIFICATION_TYPE_ALERT: '@notification-type/alert',
    NOTIFICATION_TYPE_DANGER: '@notification-type/danger'
  },
  SOCKETS: {
    ROOM_TYPES: {
      NOTIFICATIONS_RT_READ_NOTIFICATIONS: '@room-types/notifications/read-notifications'
    },
    EVENTS: {
      NOTIFICATIONS_EVENT_NEW_NOTIFICATION: '@socket-events/notifications/new-notification'
    }
  },
  PUSH_NOTIFICATIONS_SERVICES: {
    EXPO: '@push-notifications-service/expo'
  },
  CHANNEL_IDS: {
    DEFAULT_CHANNEL: 'default-channel',
    ACADEMIC_YEARS_MODULE_NAME: '@module/academic-years',
    ANNOUNCEMENTS_MODULE_NAME: '@module/announcements',
    AUTH_MODULE_NAME: '@module/authentication',
    CLASSES_MODULE_NAME: '@module/classes',
    COURSE_GRADEBOOK_POLICIES_MODULE_NAME: '@module/course-gradebook-policies',
    COURSES_MODULE_NAME: '@module/courses',
    COURSE_TEMPLATES_MODULE_NAME: '@module/course-templates',
    GRADEBOOK_SYSTEMS_MODULE_NAME: '@module/gradebook-systems',
    GRADE_CATEGORIES_MODULE_NAME: '@module/grade-categories',
    MESSAGES_MODULE_NAME: '@module/messages',
    NOTIFICATIONS_MODULE_NAME: '@module/notifications',
    ORGANIZATIONS_MODULE_NAME: '@module/organizations',
    ROLES_MODULE_NAME: '@module/roles',
    SCHOOLS_MODULE_NAME: '@module/schools',
    SEMESTERS_MODULE_NAME: '@module/semesters',
    STAGE_GRADEBOOK_DISPLAY_MODULE_NAME: '@module/stage-gradebook-display',
    STAGES_MODULE_NAME: '@module/stages',
    SUBJECTS_MODULE_NAME: '@module/subjects',
    USERS_MODULE_NAME: '@module/users',
    MATERIALS_MODULE_NAME: '@module/materials',
    GRADABLE_ITEM_MODULE_NAME: '@module/gradable-item'
  },
  CHANNEL_NAMES: {
    DEFAULT_CHANNEL: 'Default Channel',
    ACADEMIC_YEARS_MODULE_NAME: 'Academic Years',
    ANNOUNCEMENTS_MODULE_NAME: 'Announcement',
    AUTH_MODULE_NAME: 'Authentication',
    CLASSES_MODULE_NAME: 'Classes',
    COURSE_GRADEBOOK_POLICIES_MODULE_NAME: 'Course gradebook policy',
    COURSES_MODULE_NAME: 'Courses',
    COURSE_TEMPLATES_MODULE_NAME: 'Course templates',
    GRADEBOOK_SYSTEMS_MODULE_NAME: 'Gradebook systems',
    GRADE_CATEGORIES_MODULE_NAME: 'Grade categories',
    MESSAGES_MODULE_NAME: 'Messages',
    NOTIFICATIONS_MODULE_NAME: 'Notifications',
    ORGANIZATIONS_MODULE_NAME: 'Organizations',
    ROLES_MODULE_NAME: 'Roles',
    SCHOOLS_MODULE_NAME: 'Schools',
    SEMESTERS_MODULE_NAME: 'Semesters',
    STAGE_GRADEBOOK_DISPLAY_MODULE_NAME: 'Stage gradebook display',
    STAGES_MODULE_NAME: 'Stages',
    SUBJECTS_MODULE_NAME: 'Subjects',
    USERS_MODULE_NAME: 'Users',
    MATERIALS_MODULE_NAME: 'Materials',
    GRADABLE_ITEM_MODULE_NAME: 'Gradable item'
  },
  CHANNEL_DESCRIPTION: {
    DEFAULT_CHANNEL: null,
    ACADEMIC_YEARS_MODULE_NAME: null,
    ANNOUNCEMENTS_MODULE_NAME: null,
    AUTH_MODULE_NAME: null,
    CLASSES_MODULE_NAME: null,
    COURSE_GRADEBOOK_POLICIES_MODULE_NAME: null,
    COURSES_MODULE_NAME: null,
    COURSE_TEMPLATES_MODULE_NAME: null,
    GRADEBOOK_SYSTEMS_MODULE_NAME: null,
    GRADE_CATEGORIES_MODULE_NAME: null,
    MESSAGES_MODULE_NAME: null,
    NOTIFICATIONS_MODULE_NAME: null,
    ORGANIZATIONS_MODULE_NAME: null,
    ROLES_MODULE_NAME: null,
    SCHOOLS_MODULE_NAME: null,
    SEMESTERS_MODULE_NAME: null,
    STAGE_GRADEBOOK_DISPLAY_MODULE_NAME: null,
    STAGES_MODULE_NAME: null,
    SUBJECTS_MODULE_NAME: null,
    USERS_MODULE_NAME: null,
    MATERIALS_MODULE_NAME: 'All courses materials related notifications',
    GRADABLE_ITEM_MODULE_NAME: null
  }
};